<template>
  <div>
    <div class="icon-nav">
      <ul class="flex items-center justify-end gap-1 md:gap-1 list-none m-0 p-0">
        <!-- Theme Toggle (Dark / Light) -->
        <li>
          <ThemeToggle />
        </li>

        <!-- Shipping Progress (Authenticated) -->
        <li v-if="isAuthenticated" class="hidden sm:block group relative">
          <div class="bg-[#009d66]/5 rounded-full px-3 py-1.5 border border-transparent hover:bg-[#008556]/10 hover:border-[#008556] transition-all cursor-pointer">
            <div
              class="absolute top-full right-0 mt-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 whitespace-nowrap min-w-max">
              <div v-if="isShippingCostAdded">
                {{ $t("shipping_cost_added_confirmation", { percentage: '100' }) }}
              </div>
              <div v-else-if="cfranco == 0">
                {{ totalDeliverables }} €
              </div>
              <div v-else>
                {{ $t("order_ship_percentage", { percentage: shippingProcessInPercentage }) }}
              </div>
              <div class="absolute -top-1 right-4 w-2 h-2 bg-gray-900 rotate-45"></div>
            </div>
            <NuxtLinkLocale :to="{ path: '/order/deliverables' }" class="flex items-center text-primary no-underline">
              <template v-if="cfranco">
                <span class="text-xs font-bold">{{ shippingProcessInPercentage }}</span>
                <i class="fa fa-percent text-xs ml-0.5"></i>
              </template>
              <span class="text-xs text-[#009d66] font-bold" v-else>{{ totalDeliverables }} €</span>
              <i class="fa fa-spinner text-[#009d66] ml-2 animate-spin-slow"></i>
            </NuxtLinkLocale>
          </div>
        </li>

        <li v-if="isAuthenticated" id="accounts-finance" class="hidden sm:block">
          <div v-if="isAccountingReq === 'red'" class="group relative">
            <!-- Tooltip code same -->
            <div
              class="absolute top-full right-0 mt-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 whitespace-nowrap">
              {{ $t("payment_overdue") }}
              <div class="absolute -top-1 right-2 w-2 h-2 bg-gray-900 rotate-45"></div>
            </div>
            <NuxtLinkLocale :to="{ path: '/order/account-status' }"
              class="flex items-center justify-center w-8 h-8 rounded-full bg-red-50 text-red-500 hover:bg-red-100 transition-colors">
              <i class="fa fa-exclamation-triangle text-lg" aria-hidden="true"></i>
            </NuxtLinkLocale>
          </div>
          <div v-else-if="isAccountingReq === 'orange'" class="group relative">
            <!-- Tooltip code same -->
            <div
              class="absolute top-full right-0 mt-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 whitespace-nowrap">
              {{ $t("payment_overdue") }}
              <div class="absolute -top-1 right-2 w-2 h-2 bg-gray-900 rotate-45"></div>
            </div>
            <NuxtLinkLocale :to="{ path: '/order/account-status' }"
              class="flex items-center justify-center w-8 h-8 rounded-full bg-orange-50 text-orange-500 hover:bg-orange-100 transition-colors">
              <i class="fa fa-exclamation-circle text-lg" aria-hidden="true"></i>
            </NuxtLinkLocale>
          </div>
          <div v-else class="group relative">
            <!-- Tooltip code same -->
            <div
              class="absolute top-full right-0 mt-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 whitespace-nowrap">
              {{ $t("payment_ok") }}
              <div class="absolute -top-1 right-2 w-2 h-2 bg-gray-900 rotate-45"></div>
            </div>
            <NuxtLinkLocale :to="{ path: '/order/account-status' }"
              class="flex items-center justify-center w-8 h-8 rounded-full border border-transparent bg-[#009d66]/5 text-[#009d66] hover:bg-[#009d66]/10 hover:border-[#009d66] transition-colors">
              <i class="fa fa-check-circle text-lg" aria-hidden="true"></i>
            </NuxtLinkLocale>
          </div>
        </li>

        <!-- Phone -->
        <li class="hidden md:block group relative">
          <div
            class="absolute top-full right-0 mt-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 whitespace-nowrap">
            {{ $t("call_us") }}: {{ "+32 (0) 818-302-02" }}
            <div class="absolute -top-1 right-2 w-2 h-2 bg-gray-900  rotate-45"></div>
          </div>
          <a href="tel:+32081830202" aria-label="Telephone"
            class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-[#009d66]/5 border border-transparent hover:border-[#009d66] text-green-600 hover:text-green-700 hover:scale-105 transition-all">
            <i class="fa fa-phone text-lg" aria-hidden="true"></i>
          </a>
        </li>

        <div v-if="isAuthenticated">
          <li v-if="showTourBtn" class="hidden md:block group relative">
            <!-- Tooltip -->
            <div
              class="absolute top-full right-0 mt-2 px-3 py-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 whitespace-nowrap">
              {{ $t("Tutorial") }}
              <div class="absolute -top-1 right-2 w-2 h-2 bg-gray-900 rotate-45"></div>
            </div>
            <button @click="emitOpenTour"
              class="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 bg-transparent border-none cursor-pointer">
              <i class="fa fa-lightbulb-o text-gray-600 text-xl hover:text-primary transition-colors"
                aria-hidden="true"></i>
            </button>
          </li>
        </div>

        <!-- User Account Dropdown -->
        <li class="relative group" v-if="isAuthenticated" ref="userDropdownRef" @mouseenter="showUserDropdown = true" @mouseleave="closeUserDropdown">
          <div
            @click="toggleUserDropdown"
            class="flex items-center cursor-pointer text-gray-600 hover:text-primary transition-colors px-2 py-1 rounded-md hover:bg-gray-50">
            <i class="fa fa-user text-xl" aria-hidden="true"></i>
            <p v-if="cldUser && cldUser.name" class="text-xs font-semibold uppercase ml-2 hidden lg:block">
              {{ cldUser.name?.substring(0, 30).toLowerCase() }}
            </p>
            <i class="fa fa-angle-down ml-1 text-xs" aria-hidden="true"></i>
          </div>
          <!-- Dropdown for authenticated users -->
          <ul
            class="absolute right-0 top-full mt-2 bg-white shadow-[0_8px_20px_rgba(8,184,81,0.2)] ring-1 ring-[rgba(8,184,81,0.2)] border border-[rgba(8,184,81,0.25)] rounded-lg py-1 min-w-[260px] max-h-[70vh] overflow-y-auto opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 transform origin-top-right pointer-events-auto" 
            :class="{ 'opacity-100 visible': showUserDropdown }">
            <li>
              <div @click.stop="goToProfile"
                class="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary text-sm cursor-pointer">
                <i class="fa fa-user-circle mr-2"></i> {{ $t("profile") }}
              </div>
            </li>
            <li class="my-1 border-t border-gray-100"></li>
            <li>
              <NuxtLinkLocale :to="{ path: '/order/account-status' }" @click="closeUserDropdown"
                class="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary text-sm">
                <i class="fa "></i>{{ $t('menu.account_status') }}
              </NuxtLinkLocale>
            </li>
            <li>
              <div @click.stop="showDocumentsSubmenu = !showDocumentsSubmenu"
                class="flex items-center justify-between px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary text-sm cursor-pointer">
                <span>{{ $t('menu.documents_history') }}</span>
                <i class="fa" :class="showDocumentsSubmenu ? 'fa-angle-up' : 'fa-angle-down'"></i>
              </div>
              <ul v-if="showDocumentsSubmenu" class="bg-gray-50/50 border-t border-gray-100 border-b border-gray-100 py-1">
                <li>
                  <NuxtLinkLocale :to="{ path: '/order/history' }" @click="closeUserDropdown"
                    class="block pl-8 pr-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary text-sm">
                    {{ $t('menu.documents') }}
                  </NuxtLinkLocale>
                </li>
                <li v-if="isApiGatewayAccess">
                  <NuxtLinkLocale :to="{ path: '/order/dropship-history' }" @click="closeUserDropdown"
                    class="block pl-8 pr-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary text-sm">
                    {{ $t('menu.dropship_order_history') }}
                  </NuxtLinkLocale>
                </li>
                <li>
                  <NuxtLinkLocale :to="{ path: '/pricedown' }" @click="closeUserDropdown"
                    class="block pl-8 pr-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary text-sm">
                    {{ $t('menu.pricedowns') }}
                  </NuxtLinkLocale>
                </li>
              </ul>
            </li>
            <li>
              <div @click.stop="showOrdersSubmenu = !showOrdersSubmenu"
                class="flex items-center justify-between px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary text-sm cursor-pointer">
                <span>{{ $t('menu.orders') }}</span>
                <i class="fa" :class="showOrdersSubmenu ? 'fa-angle-up' : 'fa-angle-down'"></i>
              </div>
              <ul v-if="showOrdersSubmenu" class="bg-gray-50/50 border-t border-gray-100 border-b border-gray-100 py-1">
                <li>
                  <NuxtLinkLocale :to="{ path: '/order/cartmanagement' }" @click="closeUserDropdown"
                    class="block pl-8 pr-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary text-sm">
                    {{ $t('menu.cart_management') }}
                  </NuxtLinkLocale>
                </li>
                <li>
                  <NuxtLinkLocale :to="{ path: '/order/searchhistory' }" @click="closeUserDropdown"
                    class="block pl-8 pr-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary text-sm">
                    {{ $t('menu.order_history') }}
                  </NuxtLinkLocale>
                </li>
                <li>
                  <NuxtLinkLocale :to="{ path: '/order/orderedProducts' }" @click="closeUserDropdown"
                    class="block pl-8 pr-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary text-sm">
                    {{ $t('menu.back_orders') }}
                  </NuxtLinkLocale>
                </li>
                <li>
                  <NuxtLinkLocale :to="{ path: '/order/deliverables' }" @click="closeUserDropdown"
                    class="block pl-8 pr-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary text-sm">
                    {{ $t('menu.deliverable_orders') }}
                  </NuxtLinkLocale>
                </li>
                <li>
                  <NuxtLinkLocale :to="{ path: '/order/unavailableDeliveries' }" @click="closeUserDropdown"
                    class="block pl-8 pr-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary text-sm">
                    {{ $t('menu.awaiting_delivery') }}
                  </NuxtLinkLocale>
                </li>
              </ul>
            </li>
            <li class="my-1 border-t border-gray-100"></li>
            <li v-if="isSuAdmin">
              <div @click.stop="goToAdmin"
                class="block px-4 py-2 text-red-700 hover:bg-red-50 hover:text-red-800 text-sm font-semibold cursor-pointer">
                <i class="fa fa-shield mr-2"></i> {{ $t('admin') }}
              </div>
            </li>
            <li v-if="isSuAdmin">
              <NuxtLinkLocale :to="{ path: '/admin/notification-hub' }" @click="closeUserDropdown"
                class="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary text-sm">
                <i class="fa fa-bell mr-2"></i> {{ $t('notification_hub') }}
              </NuxtLinkLocale>
            </li>
            <li>
              <div @click.stop="handleLogout"
                class="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary text-sm cursor-pointer">
                <i class="fa fa-sign-out mr-2"></i> {{ $t("logout") }}
              </div>
            </li>
          </ul>

        </li>

        <!-- Login Button (Guest only) -->
        <li v-if="!isAuthenticated" >
          <NuxtLink @click="setAndRedirect"
            class="inline-flex items-center justify-center px-4 py-2 text-gray-600 hover:text-primary text-sm font-semibold transition-colors cursor-pointer">
            {{ $t("login") }}
          </NuxtLink>
        </li>

        <!-- Sign Up Button (Guest only) -->
        <li v-if="!isAuthenticated" >
          <NuxtLinkLocale
            class="cld-btn cld-btn-primary"
            :to="{ path: '/account/pre-signup' }">
            <i class="fa fa-user-plus mr-2"></i>
            {{ $t("login_p.create_account") }}
          </NuxtLinkLocale>
        </li>

        <!-- Shopping Cart (Authenticated) -->
        <li class="relative group ml-2" v-if="isAuthenticated" @mouseenter="showCartDropdown = true" @mouseleave="showCartDropdown = false">
          <div class="mt-0">
            <button
              class="relative flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-gray-600 hover:bg-primary/10 hover:text-primary transition-all duration-200 border-none cursor-pointer"
              @click="goToCart">
              <span
                class="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center shadow-sm">
                {{ tweenedQty.number.toFixed(0) }}
              </span>
              <i class="fa fa-shopping-cart text-lg"></i>
            </button>
          </div>
          <!-- Cart Dropdown same structure but styled -->
          <ul
            class="absolute right-0 top-full mt-2 bg-white shadow-[0_8px_20px_rgba(8,184,81,0.2)] ring-1 ring-[rgba(8,184,81,0.2)] border border-[rgba(8,184,81,0.25)] rounded-lg py-2 min-w-[320px] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 pointer-events-auto"
            :class="{ 'opacity-100 visible': showCartDropdown }"
            v-if="cart?.items?.length">
            <li v-for="(item, index) in displayCartItems" :key="index"
              class="px-4 py-3 border-b border-gray-100 hover:bg-gray-50">
              <div class="flex gap-3">
                <div class="flex-1">
                  <NuxtLinkLocale :to="{
                    path:
                      '/products/' +
                      item.articleId +
                      '/' +
                      item.name.replaceAll(/[^a-zA-Z0-9]+/g, '-').toLowerCase(),
                  }">
                    <h4 class="text-sm font-medium text-gray-900 hover:text-primary line-clamp-2 leading-tight mb-1">{{
                      item.name }}</h4>
                  </NuxtLinkLocale>
                  <div class="flex justify-between items-center text-xs text-gray-500">
                    <span>Qty: {{ item.quantity }}</span>
                    <span class="font-bold">{{ item.total }} €</span>
                  </div>
                </div>
              </div>
            </li>
            <li v-if="hasMoreCartItems" class="px-4 py-2 border-b border-gray-100 bg-white">
              <NuxtLinkLocale :to="{ path: '/account/cart' }"
                class="block text-sm text-primary hover:underline">
                {{ $t('see_more') }}
              </NuxtLinkLocale>
            </li>
            <li class="px-4 py-3 border-b border-gray-100 bg-gray-50">
              <div class="flex justify-between items-center">
                <span class="font-medium text-gray-700">{{ $t("subtotal") }}:</span>
                <span class="font-bold text-lg text-primary">{{ cart.amountIncludingVat }} €</span>
              </div>
            </li>
            <li class="p-3">
              <NuxtLinkLocale :to="{ path: '/account/cart' }"
                class="block w-full text-center px-4 py-2.5 bg-primary text-white font-medium rounded-lg hover:bg-primary/90 transition-colors shadow-sm">
                {{ $t("checkout") }}
              </NuxtLinkLocale>
            </li>
          </ul>
          <ul
            class="absolute right-0 top-full mt-2 bg-white shadow-[0_8px_20px_rgba(8,184,81,0.2)] ring-1 ring-[rgba(8,184,81,0.2)] border border-[rgba(8,184,81,0.25)] rounded-lg py-4 min-w-[200px] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 text-center pointer-events-auto"
            :class="{ 'opacity-100 visible': showCartDropdown }"
            v-else>
            <li class="px-4 text-gray-500 text-sm">
              <i class="fa fa-shopping-basket text-4xl text-gray-200 mb-2 block"></i>
              {{ $t("your_cart_is_currently_empty") }}
            </li>
          </ul>
        </li>

        <!-- Language Selector -->
        <li class="relative group ml-2" v-if="language" ref="languageDropdownRef" @mouseenter="showLanguageDropdown = true" @mouseleave="showLanguageDropdown = false">
          <div class="cursor-pointer p-0.5 rounded border border-gray-200 hover:border-gray-300" @click="toggleLanguageDropdown">
            <img :src="imgSource" alt="Language" class="w-6 h-4 object-cover rounded-[1px]">
          </div>
          <div
           class="absolute right-0 top-full mt-1 bg-white shadow-[0_8px_20px_rgba(8,184,81,0.2)] ring-1 ring-[rgba(8,184,81,0.2)] border border-[rgba(8,184,81,0.25)] rounded-md py-4 px-4 opacity-0 invisible pointer-events-none group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto transition-all duration-200 z-50 min-w-[200px] pointer-events-auto" :class="{ 'opacity-100 visible pointer-events-auto': showLanguageDropdown }">
            <!-- Replaced list with Grid for better width usage -->
            <div class="text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wide">Select Language</div>
            <ul class="grid grid-cols-2 gap-2 list-none m-0 p-0 pointer-events-auto">
              <li class="flex items-center gap-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
                @click.stop="languageSelection('fr')">
                <img class="w-6 h-4 object-cover rounded shadow-sm" alt="french" src="~~/assets/language/fr.svg" />
                <span class="text-xs font-medium text-gray-700">French</span>
              </li>
              <li class="flex items-center gap-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
                @click.stop="languageSelection('en')">
                <img class="w-6 h-4 object-cover rounded shadow-sm" alt="english" src="~~/assets/language/uk.svg" />
                <span class="text-xs font-medium text-gray-700">English</span>
              </li>
              <li class="flex items-center gap-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
                @click.stop="languageSelection('de')">
                <img class="w-6 h-4 object-cover rounded shadow-sm" alt="german" src="~~/assets/language/de.svg" />
                <span class="text-xs font-medium text-gray-700">German</span>
              </li>
              <li class="flex items-center gap-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
                @click.stop="languageSelection('nl')">
                <img class="w-6 h-4 object-cover rounded shadow-sm" alt="dutch" src="~~/assets/language/nl.svg" />
                <span class="text-xs font-medium text-gray-700">Dutch</span>
              </li>
              <li class="flex items-center gap-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
                @click.stop="languageSelection('es')">
                <img class="w-6 h-4 object-cover rounded shadow-sm" alt="spanish" src="~~/assets/language/es.svg" />
                <span class="text-xs font-medium text-gray-700">Spanish</span>
              </li>
              <li class="flex items-center gap-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
                @click.stop="languageSelection('sv')">
                <img class="w-6 h-4 object-cover rounded shadow-sm" alt="swedish" src="~~/assets/language/sv.svg" />
                <span class="text-xs font-medium text-gray-700">Swedish</span>
              </li>
              <li class="flex items-center gap-2 p-1 hover:bg-gray-50 rounded cursor-pointer"
                @click.stop="languageSelection('it')">
                <img class="w-6 h-4 object-cover rounded shadow-sm" alt="italian" src="~~/assets/language/it.svg" />
                <span class="text-xs font-medium text-gray-700">Italian</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import { onMounted, onBeforeUnmount, reactive } from "vue";
import { useCartStore } from "~/store/CartStore";
import { useI18n } from "vue-i18n";
import { useUtilityStore } from "~/store/UtililityStore";
import { useUserStore } from "~/store/UserStore";
import { useOrderStore } from "~/store/OrderStore";
import { useShippingStore } from "~/store/ShippingStore";

import { useRouter } from 'vue-router';


import { useProductStore } from "~/store/ProductStore";
import gsap from 'gsap'


const route = useRoute();
const router = useRouter();
const cartStore = useCartStore();
const userStore = useUserStore();
const orderStore = useOrderStore();
const shippingStore = useShippingStore();
const productStore = useProductStore();
const utilityStore = useUtilityStore();
const localePath = useLocalePath();
const qtyCart = computed(() => cartStore.qtyCart);
const cart = computed(() => cartStore.cartData);

const displayCartItems = computed(() => (cart.value?.items || []).slice(0, 5));
const hasMoreCartItems = computed(() => (cart.value?.items?.length || 0) > 5);


const { locale } = useI18n();

const accountingSituation = computed(() => orderStore.accountingSituation);
const isShippingCostAdded = computed(() => shippingStore.isShippingCostAdded)
const totalDeliverables = computed(() => floatOrZero(orderStore.totalDeliverables))
const isAuthenticated = computed(() => userStore.isAuthenticated);
const cldUser = computed(() => userStore.cldUser);
const cfranco = computed(() => parseInt(cldUser.value?.cfranco));
const isSuAdmin = computed(() => {
  
  return cldUser.value?.roles?.includes('Super-User');
});
const logout = async () => {
  // Check if user is actually authenticated before allowing logout
  if (!isAuthenticated.value || !userStore.isAuthenticated) {
    console.warn('User not authenticated, blocking logout');
    return;
  }
  
  // Prevent concurrent logout attempts
  if (isProcessingLogout) {
    console.warn('Logout already in progress, ignoring');
    return;
  }
  
  // Prevent rapid repeated logout attempts using sessionStorage
  const logoutKey = 'lastLogoutTime';
  const storedLogoutTime = parseInt(sessionStorage.getItem(logoutKey) || '0');
  const now = Date.now();
  
  if (now - storedLogoutTime < MIN_LOGOUT_INTERVAL) {
    console.warn('Logout attempt too soon after previous logout, blocking');
    return;
  }
  
  isProcessingLogout = true;
  
  // Mark this time in sessionStorage so it persists across redirects
  sessionStorage.setItem(logoutKey, now.toString());
  lastLogoutTime = now;
  
  try {
    console.log('Starting logout...');
    
    // Clear stores and cookies
    cartStore.resetCartStates();
    await userStore.logout();
    productStore.setProductsBackOrders({});
    useCookie("isAuthenticated").value = null;
    
    await nextTick();
    
    console.log('Logout complete, navigating...');
    
    // Simple page reload and navigation
    window.location.href = localePath("/account/login");
  } catch (error) {
    console.error('Logout error:', error);
    isProcessingLogout = false;
    // Force navigation even if logout fails
    window.location.href = localePath("/account/login");
  }
};

const handleLogout = async () => {
  closeUserDropdown();
  await logout();
};

const selectedLocale = computed(() => utilityStore.selectedLocale);
const language = ref('');
const showLanguageDropdown = ref(false);
const languageDropdownRef = ref(null);
const showUserDropdown = ref(false);
const showAccountSubmenu = ref(false);
const showDocumentsSubmenu = ref(false);
const showOrdersSubmenu = ref(false);
const showCartDropdown = ref(false);
const userDropdownRef = ref(null);
const tweenedQty = reactive({ number: 0 });
let lastLogoutTime = 0;
const MIN_LOGOUT_INTERVAL = 10000; // Prevent logouts within 10 seconds
let isProcessingLogout = false;

const handleClickOutside = (e) => {
  // This is no longer used - dropdowns are managed locally
  return;
};

onMounted(() => {
  setTimeout(() => {
    language.value = selectedLocale.value || locale.value;
    if (isAuthenticated.value) {
      cartStore.getFromCart();
    }
  }, 0);
});

watch(isAuthenticated, (newValue) => {
  // When user successfully logs in, reset logout prevention flag
  if (newValue) {
    console.log('User logged in, clearing logout prevention');
    sessionStorage.removeItem('lastLogoutTime');
    lastLogoutTime = 0;
    isProcessingLogout = false;
  }
  // Reset dropdowns when auth state changes
  showUserDropdown.value = false;
  closeUserDropdown();
  showCartDropdown.value = false;
  showLanguageDropdown.value = false;
});

watch(selectedLocale, () => {
  language.value = selectedLocale.value || locale.value;
})

const languageSelection = (language) => {
  utilityStore.setLanguage(language);
  showLanguageDropdown.value = false;
};

const toggleLanguageDropdown = () => {
  showLanguageDropdown.value = !showLanguageDropdown.value;
};

const toggleUserDropdown = () => {
  showUserDropdown.value = !showUserDropdown.value;
};

const closeUserDropdown = () => {
  showUserDropdown.value = false;
  showAccountSubmenu.value = false;
  showDocumentsSubmenu.value = false;
  showOrdersSubmenu.value = false;
};

const goToProfile = () => {
  closeUserDropdown();
  navigateTo(localePath('/user/profile'));
};

const goToAdmin = () => {
  showUserDropdown.value = false;
  navigateTo(localePath('/su-admin/attributes'));
};

const goToCart = () => {
  navigateTo(localePath('/account/cart'));
};

const imgSource = computed(() => languageMap[language.value]);

const isAccountingReq = computed(() => {
  const maxDaysOver = +accountingSituation.value?.maxDaysOver;
  if (accountingSituation.value?.color === 'red'
    || maxDaysOver > 3) {
    return 'red';
  }
  if (accountingSituation.value?.color === 'orange'
    || (maxDaysOver > 0 && maxDaysOver <= 3)) {
    return 'orange';
  }
  else {
    return 'green';
  }

})

watch(
  qtyCart,
  (n) => {
    gsap.to(tweenedQty, { duration: 0.5, number: Number(n) || 0 })
  }
)

const shippingProcessInPercentage = computed(() => {
  if (isAuthenticated.value) {

    if (!totalDeliverables.value) {
      return 0;
    }
    if (isShippingCostAdded.value || (cfranco.value && totalDeliverables.value >= cfranco.value)) {
      return '100';
    }
    //TODO DISCUSS WITH BOSS
    if (!cfranco.value) {
      return 0;
    }
    const percentage = (totalDeliverables.value / cfranco.value) * 100
    return isNaN(percentage) ? 0 : parseInt(percentage);
  }
})

const allowedToursRouteNames = ["products-search"]

const showTourBtn = computed(() => allowedToursRouteNames.includes(route.name))

const emitOpenTour = () => {
  EventBus.emit("open_tour");
}

const setAndRedirect = () => {
  //prevent adding redirect param for home page
  if (route.path === `/${locale.value}/account/login`) {
    return
  }

  if ([`/${locale.value}`, `/${locale.value}/account/pre-signup`].includes(route.path) || route.path.startsWith(`/${locale.value}/account/post-signup`)) {
    return router.replace(`/${locale.value}/account/login`)
  }
  return router.replace(`/${locale.value}/account/login?redirectTo=${route.fullPath}`)
}

</script>

<style>
/* Minimal legacy styles */
</style>
